import i18n from "@/i18n";
const state = {
    autoRefreshTimeOffset: 1,
    loading: false,
    alertData: [],
    alertHeader: [
        { text: i18n.t("common.table.login"), value: "login" },
        {
            text: i18n.t("common.table.name"),
            value: "name",
            sortable: false,
        },
        { text: "Book", value: "books" },
        {
            text: i18n.t("common.table.ccy"),
            value: "ccy",
        },
        {
            text: i18n.t("common.table.today_open_trades_profit"),
            value: "today_open_trades_profit",
        },
        {
            text: i18n.t("common.table.top_symbol"),
            value: "top_symbol",
        },
        {
            text: i18n.t("common.table.trigger_time"),
            value: "trigger_time",
        },
    ],
    csvHeader: {
        "Server Name": "server_name",
        Login: "login",
        Name: "name",
        Book: "books",
        CCY: "ccy",
        "PNL USD(Today)": "today_open_trades_profit",
        Symbol: "top_symbol",
        "Trigger Time": "trigger_time",
    },
    selectedDate: null,
};

const actions = {
    processLargePNL({ commit }, data) {
        let result = [];
        for (let item in data) {
            let temp = data[item];
            temp.login = item.split(":").slice(1,3).join(":")
            temp.books = temp.books.join(",");
            temp.name = item.split(":").slice(3).join(" ");
            temp.today_open_trades_profit = temp.todayOpenTradesProfit;
            temp.top_symbol = temp.maxPNLSymbol;

            result.push(temp);
        }

        commit("UPDATE_ALERT_DATA", result);
    },
};

const mutations = {
    /**
     * Update alert data
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_ALERT_DATA(state, data) {
        state.alertData = data;
    },
    /**
     * Update loading
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_LOADING(state, data) {
        state.loading = data;
    },
    UPDATE_ALERT_HEADER(state, data) {
        state.alertHeader = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
